<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content fxLayout="column" fxLayoutAlign="start">
    <mat-horizontal-stepper [linear]="true" class="pt-16" labelPosition="bottom" #stepper>
        <mat-step [completed]="!!selectedUser">
            <ng-template matStepLabel>{{ 'USER.PLURAL' | translate }}</ng-template>

            <div fxLayout="row" fxLayoutAlign="flex-end center" class="mb-12">
                <app-search-outline [searchInput]="searchInput"></app-search-outline>
            </div>

            <div class="w-100-p table-wrapper" *ngIf="dataSource">
                <mat-table #table [dataSource]="dataSource" matSort>
                    <!-- Avatar Column -->
                    <ng-container matColumnDef="avatar">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            <div class="relative" #avatarCell>
                                <img class="avatar" *ngIf="user?.avatar.src; else initials" [alt]="user.fullName" [src]="user.avatar.src" />
                                <ng-template #initials>
                                    <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ user.fullName | initials }}</div>
                                </ng-template>
                                <ng-template [onlineStateIndicator]="user.isOnline"> </ng-template>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <!-- First Name Column -->
                    <ng-container matColumnDef="firstName">
                        <mat-header-cell class="narrow" *matHeaderCellDef mat-sort-header> {{ 'GENERAL.PROPERTY.FIRST_NAME' | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let user" class="narrow">
                            <p #firstNameRow class="text-truncate">
                                {{ user.firstName }}
                            </p>
                        </mat-cell>
                    </ng-container>

                    <!-- Last Name Column -->
                    <ng-container matColumnDef="lastName">
                        <mat-header-cell class="narrow" *matHeaderCellDef mat-sort-header>
                            {{ 'GENERAL.PROPERTY.LAST_NAME' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let user" class="narrow">
                            <p #lastNameRow class="text-truncate">
                                {{ user.lastName }}
                            </p>
                        </mat-cell>
                    </ng-container>

                    <!-- Email Column -->
                    <ng-container matColumnDef="email">
                        <mat-header-cell class="wider" *matHeaderCellDef mat-sort-header fxHide fxShow.gt-xs>
                            {{ 'GENERAL.PROPERTY.EMAIL' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let user" fxHide fxShow.gt-xs>
                            <p #lastNameRow class="text-truncate">{{ user.email }}</p>
                        </mat-cell>
                    </ng-container>

                    <!-- Buttons Column -->
                    <ng-container matColumnDef="buttons">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            <div fxFlex="row" fxLayoutAlign="end center">
                                <app-flat-button [label]="'GENERAL.BUTTON.SELECT'" (onClick)="addToList(user)" [disabled]="selectedUser" *ngIf="!user.selected"></app-flat-button>
                                <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="removeFromList(user)" *ngIf="user.selected"></app-white-button>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let user; columns: displayedColumns" matRipple> </mat-row>
                </mat-table>
                <mat-paginator persistPageSize="certifications.add-certificate-dialog" [length]="totalCount$ | async" [pageSize]="5" [pageSizeOptions]="[5, 10, 25, 50]"> </mat-paginator>
            </div>
        </mat-step>

        <mat-step>
            <ng-template matStepLabel> {{ 'ALTERNATIVE.CERTIFICATE.SINGULAR' | translate }}</ng-template>
            <form [formGroup]="certificationForm">
                <div fxLayout="row" fxLayoutGap="32px">
                    <div fxFlex="50" fxLayout="column">
                        <app-certificate-taxonomy-fields
                            [providerControl]="certificationForm.get('provider')"
                            [certificationControl]="certificationForm.get('certification')"
                            (providerChange)="onProviderSelected($event)"
                            (certificationChange)="onCertificationSelected($event)"
                        ></app-certificate-taxonomy-fields>

                        <div class="w-100-p" fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="space-between center">
                            <mat-form-field class="w-100-p">
                                <input
                                    matInput
                                    [matDatepicker]="issueDatePicker"
                                    placeholder="{{ 'PAGE.CERTIFICATIONS.LABEL.ISSUE_DATE' | translate }}"
                                    formControlName="issueDate"
                                    (focus)="issueDatePicker.open()"
                                    (ngModelChange)="updateExpirationDate()"
                                />
                                <mat-datepicker-toggle matSuffix [for]="issueDatePicker"></mat-datepicker-toggle>
                                <mat-datepicker #issueDatePicker></mat-datepicker>
                            </mat-form-field>

                            <mat-form-field class="w-100-p" *ngIf="selectedCertification?.hasExpirationDate">
                                <input
                                    matInput
                                    [matDatepicker]="expirationDatePicker"
                                    [min]="minDate"
                                    placeholder="{{ 'PAGE.CERTIFICATIONS.LABEL.EXPIRATION_DATE' | translate }}"
                                    formControlName="expirationDate"
                                    (focus)="expirationDatePicker.open()"
                                />
                                <mat-datepicker-toggle matSuffix [for]="expirationDatePicker"></mat-datepicker-toggle>
                                <mat-datepicker #expirationDatePicker></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <mat-checkbox formControlName="notifyAboutExpiration" class="my-12" *ngIf="isToDoFeatureEnabled && selectedCertification?.hasExpirationDate">
                            {{ 'CERTIFICATE.NOTIFY_WHEN_IS_ABOUT_TO_EXPIRE' | translate }}
                        </mat-checkbox>

                        <mat-slide-toggle
                            class="my-12"
                            [formControl]="hasEndDate"
                            (change)="onChangeEndDateToggle($event)"
                            *ngIf="selectedCertification?.certificationName === 'other'"
                            >{{ 'GENERAL.LABEL.HAS_END_DATE' | translate }}</mat-slide-toggle
                        >

                        <div class="p-24 bg-lightgreybackground" *ngIf="hasEndDate.value">
                            <mat-form-field class="w-100-p">
                                <input
                                    matInput
                                    [matDatepicker]="expirationDatePicker"
                                    [min]="minDate"
                                    placeholder="{{ 'PAGE.CERTIFICATIONS.LABEL.EXPIRATION_DATE' | translate }}"
                                    formControlName="expirationDate"
                                    (focus)="expirationDatePicker.open()"
                                />
                                <mat-datepicker-toggle matSuffix [for]="expirationDatePicker"></mat-datepicker-toggle>
                                <mat-datepicker #expirationDatePicker></mat-datepicker>
                            </mat-form-field>

                            <mat-checkbox formControlName="notifyAboutExpiration" class="mt-12" *ngIf="isToDoFeatureEnabled">
                                {{ 'CERTIFICATE.NOTIFY_WHEN_IS_ABOUT_TO_EXPIRE' | translate }}
                            </mat-checkbox>
                        </div>
                    </div>

                    <div fxFlex="50" fxLayout="column" fxLayoutAlign="center flex-start">
                        <h2 class="mb-16 mt-0">{{ 'ALTERNATIVE.CERTIFICATE.SINGULAR' | translate }}</h2>
                        <div
                            *ngIf="!uploadedCertificateFiles.length; else fileAdded"
                            class="file-drop-container certificates-list w-100-p h-132"
                            cdkDropList
                            (drop)="onFileDropped($event)"
                            (dragover)="onDragOver($event)"
                            (dragleave)="onDragLeave($event)"
                            [class.drag-over]="isDragOver"
                        >
                            <div>
                                <div fxLayout="column" fxLayoutAlign="center center">
                                    <app-white-button class="my-12" [label]="'CONTENT.BUTTON.UPLOAD'" (onClick)="fileInput.click()" [showThreeDots]="true"></app-white-button>
                                    <input
                                        class="bg-white rounded-sm p-8 pointer border border-gray-300"
                                        type="file"
                                        style="display: none"
                                        (change)="fileChange($event.target.files)"
                                        [placeholder]="'CONTENT.BUTTON.UPLOAD' | translate"
                                        accept=".pdf"
                                        #fileInput
                                    />
                                    <p>{{ 'PAGE.MODULE_FORM.TAB.CERTIFICATE_SETTINGS.DIALOGS.ADD_CERTIFICATE_TEMPLATE_TO_MODULE.LABELS.OR_DRAG_AND_DROP' | translate }}</p>
                                </div>
                            </div>
                        </div>

                        <ng-template #fileAdded>
                            <mat-card appearance="outlined">
                                <div fxLayout="row" fxLayoutAlign="space-between center">
                                    <div fxLayout="row" fxLayoutAlign="start center">
                                        <mat-icon class="mr-8">description</mat-icon>
                                        <span>{{ uploadedCertificateFiles[0]?.name }}</span>
                                    </div>
                                    <mat-icon class="pointer" (click)="onRemoveAddedCertificate()">close</mat-icon>
                                </div>
                            </mat-card>
                        </ng-template>
                    </div>
                </div>
            </form>
        </mat-step>
    </mat-horizontal-stepper>
</div>

<div mat-dialog-actions class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="flex-end center">
    <div fxLayout="row" fxLayoutAlign="flex-start center" *ngIf="isLastStep">
        <div class="info-icon" fxLayoutAlign="center center" matTooltip="{{ 'CERTIFICATE.TOOLTIP.CREATE_SILENTLY' | translate }}" aria-label="Info icon" matTooltipClass="tooltip">
            i
        </div>
        <mat-checkbox [formControl]="createSilently" labelPosition="before" class="mr-24">
            {{ 'CERTIFICATE.CREATE_SILENTLY' | translate }}
        </mat-checkbox>
    </div>

    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

    <app-flat-button
        [label]="'GENERAL.BUTTON.NEXT'"
        class="mr-8"
        [disabled]="!selectedUser || isLastStep"
        (onClick)="goForward(stepper)"
        *ngIf="shouldShowNextButton"
    ></app-flat-button>

    <app-flat-button
        [label]="'GENERAL.BUTTON.SAVE' | translate"
        (onClick)="saveSelected()"
        [disabled]="!certificationForm.valid || !selectedUser"
        [isLoading]="isSaveButtonLoading"
        *ngIf="isLastStep"
    ></app-flat-button>
</div>
